import React, { Fragment, useEffect, useState } from 'react'
import ErrorBoundary from '../../ErrorBoundry'
import { Button, Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import AdvanceSearch from '../../CommonComponents/AdvanceSearch'
import { Accordion, AccordionDetails, Autocomplete, TextField, Typography } from '@mui/material'
import TelerikDataTable from '../../CommonComponents/TelerikDataTable'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'oidc-react'
import { useSelector } from 'react-redux'
import useSortedColumns from '../../utils/useSortedColumns'
import visibleColumns from "./visibleColumns";
import RetentionWorksheet from './Components/RetentionWorksheet'
import { Dialog } from '@progress/kendo-react-dialogs'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Icon } from '@progress/kendo-react-common'
import { advanceSearch } from '../../_helper/services/advanceSearchv2'
import { ShowError } from '../../_helper/helper'
import { loadingPanel } from '../../CommonComponents/CommonFunction'

const Retention = () => {
  const id = "RetentionList";
  const {
    columns,
    loadingSearch,
    searchResults,
    ColumnsSorted,
    searchParameter,
    // searchResults: { results, rowCount },
    searchResultsV2
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const { [id]: { results = [], rowCount } = {} } = searchResultsV2 || {};
  const navigate = useNavigate();
  const { userData } = useAuth();
  // const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  console.log(results, 'searchResultsV21221')
  const [adHocPoint, setAdHocPoint] = useState(0);

  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [searchParams, setSearchParams] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortData, setSortData] = useState([
    { field: "DepartmentName", dir: "desc"},
    { field: "PositionTitle", dir: "desc"},
    { field: "TotalScore", dir: "desc" },
    { field: "ServPt", dir: "desc"},
    { field: "APPLICATION_DATE", dir: "desc" }
  ]);
  const [pageSize, setPageSize] = useState(100);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notificationId, setNotificationId] = useState(null);
  const [defaultAdditionalWhere, setDefaultAdditionalWhere] = useState("");
  const [modalData, setModalData] = useState({})
  const [dialogOpen, setDialogOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const history = useNavigate();

  const formatDate = (date) => {
    // return dayjs(date).format('YYYY-MM-DD');
  };

  const actions = [
    {
      title: "Show Details",
      action: (props) => {
        setModalData(props?.dataItem)
        handleOpen()
      },
      icon: { iconName: 'k-icon  k-i-eye' },
      className: "font-primary",
      style: { cursor: "pointer" },

    },
  ]

  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);
  useEffect(() => {
    // console.log(searchResults);
  }, [searchResults]);
  const [sortedColumns, setSortedColumns] = useSortedColumns(
    id,
    ColumnsSorted,
    columns,
    visibleColumns,
    userData
  );

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    // setPage(1);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  useEffect(() => {
    if (searchParameter[id]?.searchParams?.length > 0) {
      setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
    }
  }, [searchParameter]);

  const handleOpen = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };
  const getAllDepName = async () => {
    // setLoading(true);
    const payload = {
      tableName: "Lk_DPDV",
      searchParams: "",
      columns: "*",
      location: "global",
      pageNumber: 1,
      pageSize: 10000,
      sortData: "Departmentname asc",
      additionalWhere: "Departmentname is not null ",
      qID: 0,
    };
    try {
      const response = await advanceSearch(payload);
      const { results } = response;
      const uniqueResults = results.filter(
        (v, i, a) => a.findIndex((t) => t.DepartmentName === v.DepartmentName) === i
      );
      setOptions(uniqueResults)
      console.log(results, 'dpdv')
    } catch (error) {
      console.error("Error fetching data:", error);
      ShowError("Error fetching data. Please try again later.");
    } finally {
      // setLoading(false);
    }
  };
  useEffect(() => {
    getAllDepName();
  }, []);



  const handleChange = (event, newValue) => {
    console.log("Selected Value:", newValue);
    setSelectedOption(newValue);
    if (!newValue) {
      setAdditionalWhere('');
    }
  };

  useEffect(() => {
    console.log(defaultAdditionalWhere, 'newValue.DepartmentName');
    if (selectedOption) { setAdditionalWhere(`DepartmentName LIKE '%${selectedOption.DepartmentName}%'`); }
  }, [selectedOption]);

  console.log(options,'departmentOptions1221')



  return (
    <ErrorBoundary>
      {" "}
      <Fragment>

        {
          loadingSearch
          && loadingPanel()
        }
        <Container fluid={true}>
          <Row className="bg-primary rounded py-3 mb-3">
            <div className='d-flex align-items-center justify-content-between'>
              <Typography variant="h5">
                <Icon
                  style={{ fontSize: "25px", margin: "10px" }}
                  name="file-ascx"
                />
                Retention
              </Typography>
              <Autocomplete
                sx={{ width: 500, background: 'white' }}
                options={options && options.length> 0 ? options.filter(d=>d.atonomous_agnecy == 0) : []}
                size='small'
                getOptionLabel={(option) => option?.DepartmentName || ''}
                value={selectedOption}
                onChange={handleChange}
                renderInput={(params) => <TextField variant='filled' size='small' {...params} label="Select Department" />}
              />
            </div>
          </Row>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody>
                  <AdvanceSearch
                    id={id}
                    gridId={id}
                    location="global"
                    columnList={"*"}
                    columnRefernces={[]}
                    tableName={"fn_RetentionGroupbyDetails"}
                    searchParams={searchParams}
                    additionalWhere={additionalWhere}
                    expanded={false}
                    sortData={sortData}
                    pageNumber={page}
                    pageSize={pageSize}
                    chooseFilterMethod={chooseFilterMethod}
                  />

                  <Accordion expanded={expandedSearchResult}>
                    <AccordionDetails>
                      {/* {loadingSearch && loadingPanel} */}
                      <div>
                        {sortedColumns.length > 0 && (
                          <TelerikDataTable
                            key={id}
                            id={id}
                            pageSize={pageSize}
                            totalCount={rowCount}
                            skip={(page - 1) * pageSize}
                            take={pageSize}
                            data={results || []}
                            sortData={sortData}
                            onFilterChange={handleFilterChange}
                            onSortChange={handleSortChange}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            selectedColumns={sortedColumns}
                            setSortedColumns={setSortedColumns}
                            actions={actions}
                            searchParams={searchParams}
                            setChooseFilterMethod={setChooseFilterMethod}
                            chooseFilterMethod={chooseFilterMethod}
                            isDashboard={true}
                            hideSaveIcon={false}
                            group={[{ field: "DepartmentName" }]}
                            header={true}
                            additionalExportPdfPayload={{
                              "columnAlignments": "[{\"ColumnName\":\"Grade/step\",\"Aliginment\":\"center\"},{\"ColumnName\":\"Salary\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Employee No.\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Service Point\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Csc Code\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Score\",\"Aliginment\":\"center\"}]",
                              "headerAliginment": "[{\"ColumnName\":\"Grade/step\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Salary\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Employee No.\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Service Point\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Csc Code\",\"Aliginment\":\"right\"},{\"ColumnName\":\"Score\",\"Aliginment\":\"center\"}]",
                            }}
                            defaultAdditionalWhere={defaultAdditionalWhere}
                          ></TelerikDataTable>
                        )}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <div>
            <Modal
              isOpen={dialogOpen}
              style={{
                maxWidth: "80%",
                width: "80%",
              }}
              zIndex={99}
            //   size="xl"
            >
              <ModalHeader>
                Retention List Detail
                <Button
                  close
                  onClick={handleClose}
                  style={{ position: "absolute", right: "1rem" }}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </ModalHeader>
              <ModalBody>
                <div style={{ zIndex: 9999999 }}>
                  <RetentionWorksheet modalData={modalData} departmentOptions={options} setAdHocPoint={setAdHocPoint} adHocPoint={adHocPoint}/>
                </div>
              </ModalBody>
            </Modal>
          </div>
        </Container>

      </Fragment>
    </ErrorBoundary>
  );
}

const dialogHeaderStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  fontSize: "18px",
  borderBottom: "1px solid #ddd",
};

const closeButtonStyle = {
  background: "none",
  border: "none",
  fontSize: "16px",
  cursor: "pointer",
};

export default Retention